<div class="step-container">
    <h1 class="text-tertiary-900">Step Three</h1>

    <h2 class="text-tertiary-900">Accept Results</h2>

    <img
        src="assets/svg/cevo-go-results.svg"
        alt="Check list"
        class="hero-image"
    />

    <p>
        Accept Cevo Go’s frequency results and press Go! Your part is done. An
        EWA Advisor completes the process and transmits your application to the
        FCC.
    </p>

    <p>
        You will receive email status updates and may track all of your Cevo
        applications online.
    </p>
</div>
